<!--
 * @Description: 软件介绍模块
-->
<template>
    <div :class="$style['m-intro']" class="enter-animate animate__fadeInUp">
        <div class="m-container" style="position: relative;">
            <div :class="$style['mask']"></div>
            <div :class="$style['container-inner']">
                <div :class="$style['module-body']" class="flex justify-center items-center">
                    <div :class="$style['intro-thumb']">
                        <div :class="$style['intro-thumb--inner']">
                            <div ref="swiperDom" class="swiper" :class="$style['swiper']">
                                <!--<div class="swiper-wrapper">
                  <div :class="$style['thumb-box']" class="swiper-slide">
                    <img
                      src="../../../assets/images/newImg/intro-thumb-1.png"
                      alt=""
                    />
                  </div>
                  <div :class="$style['thumb-box']" class="swiper-slide">
                    <img
                      src="../../../assets/images//newImg/intro-thumb-1.png"
                      alt=""
                    />
                  </div>
                  <div :class="$style['thumb-box']" class="swiper-slide">
                    <img
                      src="../../../assets/images//newImg/intro-thumb-1.png"
                      alt=""
                    />
                  </div>
                </div>-->
                            <div class="video-main">
                                <video ref="video" preload="auto" autoplay loop muted playsinline controlsList="nodownload" src="@/assets/images/video/bannerVideo.mp4" />
                            </div>
                                <!-- <video id="bannerVideo" preload="auto" autoplay loop muted playsinline>
                                    <source src="@/assets/images/video/bannerVideo.mp4" type="video/mp4">
                                </video> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import Swiper from "../../../utils/swiper";

// import Wallet from "../../assets/images/newImg/svg/wallet.svg?vue-component";
// defineOptions({ components: { Wallet } });

export default {
    components: {
        // Wallet
    },
    data() {
        return {
            swiper: null,
        }
    },
    mounted() {
        // this.$refs.video.play();
        // const swiperDom = this.$refs.swiperDom;
        // if (!swiperDom) return;
        // const $pageEl = $(`
        //     <div class="swiper-pagination"></div>
        // `).appendTo(swiperDom);
        // this.swiper = new Swiper(swiperDom, {
        //   loop: true,
        //   width: swiperDom.clientWidth,
        //   resizeObserver: true,
        //   pagination: {
        //     el: $pageEl[0],
        //     renderBullet: function(index, className) {
        //       return `<div class="${className}" data-index="${index + 1}">
        //                         <i class='ic'></i>
        //                     </div>`;
        //     }
        //   },
        //   autoplay: {
        //     delay: 5000,
        //     disableOnInteraction: false
        //   },
        //   speed: 1000,
        //   breakpoints: {
        //     1400: {
        //       width: 310
        //     }
        //   },
        //   on: {
        //     destroy() {
        //       $pageEl.remove();
        //     }
        //   }
        // });
    },

    beforeDestroy() {
        // this.swiper && this.swiper.destroy();
        // this.swiper = null;
    },
}
</script>
<style lang="scss">
.video-main{
    position: relative;
    z-index: -9999999999999;
}
</style>
<style lang="scss" module>
@import '../../../assets/uemo-scss/scss/abstracts/_mixins.scss';
@import '../../../assets/uemo-scss/scss/abstracts/_functions.scss';
.mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
    // border: 1px solid red;
    z-index: 999;
}
.m-intro {
    padding: 23px 0 128px;
    .container-inner {
        position: relative;
    }

    .module-bg--inner {
        //
    }
    .module-body {
        position: relative;
        z-index: var(--g--z-index);
    }
    .intro-thumb {
        --r: 72px;
        padding: 3px;

        border-radius: var(--r);
        background-image: conic-gradient(
            from var(--deg, 160deg) at 60% 40%,
            rgba(#885e31, 0.3),
            rgba(#885e31, 0.3),
            rgba(#ffa73d, 0.7),
            #ffa73d,
            #ffdaae,
            #ffdaae,
            #ffa73d,
            rgba(#ffa73d, 0.7),
            rgba(#885e31, 0.5),
            rgba(#885e31, 0.3),
            rgba(#885e31, 0.3)
        );
        .intro-thumb--inner {
            position: relative;

            overflow: hidden;

            padding: 9px;

            // opacity: 0;
            border-radius: calc(var(--r) - 3px);
            background-color: color(var(--g--color-bg--default));
            &::after {
                position: absolute;
                top: 2px;
                right: 2px;
                bottom: 2px;
                left: 2px;

                content: '';

                background-color: color(var(--g--color-bg--default));
                background-image: url('../../../assets/images/newImg/intro-thumb-bg.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: 100% 100%;
            }
        }
        .swiper {
            position: relative;
            z-index: var(--g--z-index);

            width: 413px;

            border-radius: calc(var(--r) - 9px);
        }
        .thumb-box {
            @include image-placeholder-v4(580, 1255);
            overflow: hidden;

            width: 413px;
        }
        :global {
            .swiper-pagination {
                position: absolute;
                z-index: var(--g--z-index);
                bottom: 64px;
                left: 0;

                display: flex;

                width: 100%;

                justify-content: center;
            }
            .swiper-pagination-bullet {
                width: 8px;
                height: 8px;
                margin: 0 3px;

                transition: 0.26s ease;

                border-radius: 3px;
                background-color: color(var(--g--color-bg--reverse));
            }
            .swiper-pagination-bullet-active {
                width: 26px;

                background-color: color(var(--g--color-theme--main));
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/compontents/newHome/index/IntroModule.vue